import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";
export const GET_BY_ID_JOB_INTERPRETER_ACTION = createAsyncThunk('/interpreter_job/get_by_id', async (userID) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_BY_ID_JOB_INTERPRETER, {
      params: {
        user_id: userID,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const INTERPRTER_RATE_AND_REVIEW_ACTION = createAsyncThunk('/interpreter/rate-and-review', async (userId) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_RATE_AND_REVIEW, {
      params: {
        user_id: userId,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const GET_UNAVAILAVILITY_ACTION = createAsyncThunk('/interpreter/unavailability', async (interpreter_id) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_UNAVAILABILTIY, {
      params: {
        interpreter_id: interpreter_id,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})